import React, { useState, useMemo, useContext, useEffect } from "react"
import { PropTypes } from "prop-types"

/** TODO: Remove once we split out helpers numbers */
function getUniqueId() {
  return Math.random().toString(36).substr(2, 16)
}

const ModalContext = React.createContext([[], () => null])

function ModalProvider({ children }) {
  const value = useState([])

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}

ModalProvider.propTypes = {
  children: PropTypes.node
}

export function useModalContext(isOpen) {
  const [values, setValues] = useContext(ModalContext)
  const uuid = useMemo(() => getUniqueId(), [])

  useEffect(() => {
    if (isOpen) {
      setValues(old => old.concat(uuid))

      return () => {
        setValues(old => old.filter(id => id !== uuid))
      }
    }
  }, [isOpen, setValues, uuid])

  return {
    hasChildren: values[values.length - 1] !== uuid,
    isChild: values[0] !== uuid
  }
}

export default ModalProvider
